import {getLastStringAfterSlash} from '@/_application/core/utils/common';
import {HighlightBrand, HighlightBrands} from '@/__generated__/__types__';
import {DynamicPageServerSideProps} from '@/_application/core/types';

export const findBrandByUrlKey = (urlKey: string, brandList: HighlightBrands) => {
    const brands = (brandList?.items?.filter(item => item) ?? []) as HighlightBrand[];
    const brand = brands?.find(brand => getLastStringAfterSlash(brand?.url ?? '') === urlKey?.toLowerCase());
    return brand;
};

export const findBrandById = (brandId: number, brandList: HighlightBrands) => {
    const brands = (brandList?.items?.filter(item => item) ?? []) as HighlightBrand[];
    const brand = brands?.find(brand => brand.id === brandId);
    return brand;
};

export const getAllStorageHighlightBrand = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    const brands = sessionStorage.getItem('highlight_brands');
    return brands ? (JSON.parse(brands) as HighlightBrands) : null;
};

//use for sorting brand by position ascending (position: 0 -> postion: 1,...)
export const compareBrandByPosition = (firstBrand: HighlightBrand, secondBrand: HighlightBrand) => {
    return (firstBrand?.position ?? 0) - (secondBrand?.position ?? 0);
};

export const storeServerData = (variables: DynamicPageServerSideProps['variables']) => {
    if (typeof window === 'undefined') {
        return;
    }

    if (sessionStorage.getItem('highlight_brands')) {
        return;
    }

    //@: Destructure attributes stored
    const {brands: highlightBrandsList} = variables ?? {brands: []};

    if (!highlightBrandsList) {
        return;
    }

    //@: store data
    sessionStorage.setItem('highlight_brands', JSON.stringify(highlightBrandsList));
};
